import { Input, Self, Optional, Component } from "@angular/core";
import { ControlValueAccessor, NgControl } from "@angular/forms";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

@Component({
    template: '',
})
export abstract class ToggleComponent implements ControlValueAccessor {
    @Input() name: string;
    @Input() error: string;
    @Input() label: string;
    @Input() showLabel = true;
    value: boolean = null;
    faCheck = faCheck;
    isChecked = undefined;

    constructor(private control: NgControl) {
        if (this.control) {
            this.control.valueAccessor = this;
        }
    }

    get invalid(): boolean {
        return this.control ? this.control.invalid : false;
    }

    get showSuccess(): boolean {
        if (!this.control) {
            return false;
        }
        const { dirty, touched } = this.control;
        return !this.control.invalid ? (dirty || touched) : false;
    }

    get showError(): boolean {
        if (!this.control) {
            return false;
        }
        const { dirty, touched } = this.control;
        return this.invalid ? (dirty || touched) : false;
    }

    onChange(value: any): void {
    }

    onTouched = () => {
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    writeValue(value: any): void {
        this.value = value;
    }
}